<template>
    <div>
        <div v-if="allPartsLoaded" class="w3-col">
            <h5 v-if="ongoing" class="flow-blue-color zero-bottom w3-animate-opacity w3-center">
                <span class="flow-margin-left font-weight-bold">
                    {{ patientTitle }}
                    <span v-if="device">
                        <i class="fa fa-mobile-alt flow-margin-right flow-green-active-color flow-padding-left" :title="$t('loggedIn')"></i>
                    </span>
                    <span class="w3-col font-weight-normal">
                        ({{ appointment.time }} - {{ safeGroup.displayName }}
                        <span v-if="safeGroup.shareRooms === true && appointment.physician"> - {{appointment.physician.name}}</span>)

                        <button v-if="appointment.hasPriority"
                                class="fa fa-star appointment-priority cursor-pointer w3-large w3-border-0 w3-transparent active">
                        </button>
                    </span>
                </span>
            </h5>

            <h5 v-if="!isCallerActive && !ongoing" class="zero-bottom w3-animate-opacity w3-center w3-padding">
                <span class="flow-margin-left font-weight-bold w3-margin-top w3-text-deep-orange">
                    <i class="fa fa-coffee"></i>
                    {{$t('ConsultationNotActive')}}
                </span>

                <p class="zero">
                    {{$t('CantCallUnlessActive')}}
                </p>
            </h5>

            <h5 v-else-if="!ongoing" class="flow-blue-color zero-bottom w3-animate-opacity w3-center">
                <span class="flow-margin-left font-weight-bold  w3-margin-top">
                    {{$t('NoOngoingConsultation')}}
                </span>
            </h5>

            <div class="w3-container text-color">
                <div>
                    <div v-if="ongoing" id="ongoing-consultation" class="w3-col w-15pc w3-center w3-margin">
                        <h6 class="zero-bottom flow-margin-top">
                                        <span class="w3-col fa fa-stack fa-2x cursor-pointer" style="margin-bottom: 15%">
                                            <i class="fa fa-circle fa-stack-1x fa-4x" style="color: lightsteelblue"></i>
                                            <i class="fa fa-bullhorn fa-stack-2x flow-blue-color"></i>
                                        </span>

                            <button id="recall-appointment" class="w3-col flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-center w3-margin-top flow-white-space"
                                    @click.prevent="recallAppointment(ongoing.patient.id, ongoing.appointment.id)">
                                <i class="fa">
                                    <b class="flow-blue-color">{{$t('callPatientAgain')}}</b>
                                </i>
                            </button>
                        </h6>
                    </div>

                    <div v-if="ongoing" class="w3-col w-60pc w3-margin">
                        <div class="w3-margin-left">
                            <h6 class="w3-col w-100pc zero-bottom flow-margin-top">
                                <i class="fa fa-birthday-cake w3-text-deep-purple flow-margin-right" :title="$t('dob')"></i>
                                <span>{{ displayIfDefined(ongoing.patient.dob) }}</span>
                            </h6>
                            <h6 class="w3-col w-100pc zero-bottom flow-margin-top">
                                <i class="fa fa-comment-dots flow-margin-right" style="color: steelblue" :title="$t('comments')"></i>
                                <span>{{ displayIfDefined(ongoing.patient.comment) }}</span>
                            </h6>
                            <h6 class="w3-col w-100pc zero-bottom flow-margin-top">
                                <i class="fa fa-tag w3-text-deep-orange flow-margin-right" :title="$t('tag')"></i>
                                <span>{{ ongoing.patient.ticket }}</span>
                            </h6>
                        </div>
                    </div>
                </div>

                <div class="w3-col w-15pc w3-center w3-margin w3-right">
                    <h6 class="zero-bottom flow-margin-top w3-margin-left">
                        <span class="w3-col fa fa-stack fa-2x cursor-pointer"
                              style="margin-bottom: 15%">
                            <i class="fa fa-circle fa-stack-1x fa-4x transform-animation"
                               v-bind:class="isCallerActive ? 'flow-green3' : 'flow-orange-text' "></i>
                            <i class="fa fa-stack-2x transform-animation"
                               v-bind:class="isCallerActive ? 'fa-stethoscope flow-green-active-color' : 'fa-coffee flow-green3'">
                            </i>
                        </span>

                        <button id="toggle-caller-status" @click="toggleCallerStatus"
                                class="w3-col flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-center w3-margin-top flow-padding flow-white-space">
                            <i class="fa">
                                <b v-if="isCallerActive" id="active-caller-status" class="flow-blue-color">
                                    {{ $t('PauseConsultations') }}
                                </b>
                                <b v-else id="paused-caller-status" class="flow-blue-color">
                                    {{ $t('ResumeConsultations') }}
                                </b>
                            </i>
                        </button>
                    </h6>
                </div>

            </div>

            <div v-if="ongoing" class="w3-container w-100pc w3-padding w3-center w3-margin-bottom">
                <div>
                    <button v-for="action in sortedRoomActions" v-bind:id="'room-action-' + action.id"
                            class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-padding w3-large w3-margin-right"
                            v-bind:style="{background: getRoomActionUISetting(action, 'bgColor')}"
                            @click="runRoomAction(action)">
                        <i class="fa w3-padding-small">
                            <b v-bind:style="{color: getRoomActionUISetting(action, 'textColor', '#094e77')}">
                                {{ $t(getRoomActionUISetting(action, 'toTranslateName')) + " " + getRoomActionUISetting(action, 'toAppendToName')}}
                            </b>
                        </i>
                    </button>
                </div>
            </div>
        </div>

        <div v-else class="w3-col w3-padding-large w3-center">
            <div>
                <h5 class="flow-blue-color zero-bottom w3-animate-opacity w3-center">
                    <span class="flow-margin-left font-weight-bold  w3-margin-top">
                        {{ $t('loading') }}
                    </span>
                    <p class="zero">
                        {{ $t('pleaseWait') }}
                    </p>
                </h5>
            </div>



        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import SpinWhileLoading from "../common/Loading";
    import {EventBus} from "../../main";
    const frc = Vue.prototype.$frc;

    export default {
        name: "OngoingConsultationCard",
        components: {SpinWhileLoading},
        props: ['ongoing', 'roomActions', 'isCallerActive', 'consultationGroup', 'noRoomsLinked'],
        computed: {
            allPartsLoaded() {
                return (this.noRoomsLinked === true) || (this.isCallerActive !== undefined && this.ongoing !== undefined);
            },
            appointment() {
                return this.ongoing ? this.ongoing.appointment : undefined;
            },
            patient() {
                return this.ongoing ? this.ongoing.patient : undefined;
            },
            patientTitle() {
                if (!this.ongoing || !this.ongoing.patient) {
                    return "";
                }
                const patient = this.ongoing.patient;

                return Vue.patientNamePlusId(patient.name, patient.internalIds)
            },
            device() {
                if (!this.ongoing || !this.ongoing.patient) {
                    return false;
                }
                const patient = this.ongoing.patient;

                return !!Vue.getValueForKey(patient.properties.entry, 'device');
            },
            sortedRoomActions() {
                var sortedActions = [];
                var app = this;
                for (var i = 0; i < app.roomActions.length; i++) {
                    sortedActions[i] = app.roomActions[i];
                    sortedActions[i].order = app.getRoomActionUISetting(app.roomActions[i], 'order');
                }
                Vue.sortByKeyInt(sortedActions, 'order');
                return sortedActions;
            },
            safeGroup() {
                return this.consultationGroup ? this.consultationGroup : {}
            }
        },
        methods: {
            displayIfDefined(val) {
                if (val && val.length > 0) {
                    return val;
                }

                return this.$t("notGiven");
            },
            toggleCallerStatus() {
                EventBus.$emit("onClickCallerStatusChange");
            },
            runRoomAction(roomAction) {
                EventBus.$emit("onClickRoomAction", roomAction);
            }
        }
    }
</script>

<style scoped>

</style>